<template>
    <div class="modal fade" id="deleteTag" tabindex="-1" role="dialog" aria-labelledby="confirmSingleDeleteProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Tag</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closePopUpAction">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
				<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
					<div
					class="spinner-border"
					style="margin:40px auto;display:block;"
					></div>
				</div>
                <div class="modal-body" v-else>
                    <p>Are you sure, you want to delete the tag ?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "closePopUpAction">No</button>
                    <button type="button" @click="deleteSelectedTags()" class="btn btn-primary">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'DeleteTagKeywordPopUp',
    data() {
        return {
			isLoading:false
        }
    },
    props: ["tag", "deleteAll", "amsCampaignId"],
	computed:{
		keyWordToTagList: {
			get() {
				return this.$store.state.campaign.keyWordToTagList;
			},
			set(val) {
				this.$store.state.campaign.keyWordToTagList = val;
			}
		}
	},
    methods: {
		deleteSelectedTags(){
			
			let payload = {
				list:this.keyWordToTagList,
				tag:this.tag,
				type:'keyword',
				delType:this.deleteAll,
				amsCampaignId:this.amsCampaignId
			}
			if(this.$route.params.sponsoredType=='sd'){
				payload['type'] = 'asin'
			}
			this.isLoading = true
			let vm = this;
			this.$store.dispatch("campaign/delTagForKeyword", payload).then((data) => {

				vm.isLoading = false
				vm.$emit("closeDelTag", vm.tag)
			})
		},
		closePopUpAction(){
			this.$emit("closeDelTag")
		}
    },
}
</script>

<style lang="scss">

</style>
